import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../../components/Dropdown/Default';
import Tooltip from '../../../../components/Tooltip';

import { generateTableBody, getItemActions } from '../../helpers';

const Body = ({ items, config, onSelectAction }) => (
  <tbody>
    {items?.map((item) => (
      <tr key={item.id}>
        {generateTableBody(item)?.map((element) => {
          switch (element.type) {
          case 'actions':
            const itemActions = getItemActions(item, config?.access);
            if (!itemActions?.length) {
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  {' '}
                </td>
              );
            }
            return (
              <td key={element.type} className={element.class} {...element.attrs}>
                <Dropdown
                  handleSelect={(...props) => onSelectAction(...props)}
                  size="xsmall"
                  title=""
                  items={itemActions}
                  forMassActions
                  classForBtnDrop="font__weight-med"
                  dropStyle="default"
                  toolbarClass="dropdown-right"
                  id={item.id}
                  item={item}
                />
              </td>
            );

          case 'amount':
            if (item?.amount_course) {
              return (
                <td key={element.type} className={element.class} {...element.attrs}>
                  <Tooltip placement="left" text={String(item?.amount_course)} tooltipClass="tooltip__left">
                    <span>
                      &asymp;
                      {' '}
                      {element?.value}
                    </span>
                  </Tooltip>
                </td>
              );
            }
            return (
              <td key={element.type} className={element.class} {...element.attrs}>
                {element?.value}
              </td>
            );

          default:
            return (
              <td key={element.type} className={element.class} {...element.attrs}>
                {element?.value}
              </td>
            );
          }
        })}
      </tr>
    ))}
  </tbody>
);

Body.propTypes = {
  items: PropTypes.array,
  config: PropTypes.object,
  onSelectAction: PropTypes.func,
};

export default Body;
